import JobDetailsFormContainer from './job_details_form_container';

const JobDetailsForm = JobDetailsFormContainer;
export default JobDetailsForm;
